<template>
  <v-dialog max-width="500" v-model="visible">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on"
        ><v-icon>account_circle</v-icon>&nbsp;{{ userName }}</v-btn
      >
    </template>
    <v-toolbar :color="$store.state.UiColors.crudToolbarDetail">
      <v-toolbar-title>Información y Customización del Usuario</v-toolbar-title>
    </v-toolbar>

    <v-card>
      <v-card-text>
        <v-container>
          <v-layout wrap>
            <v-flex xs12>
              <v-switch
                label="Tema Oscuro"
                v-model="temaOscuro"
                false-value="false"
              ></v-switch>
            </v-flex>
            <v-flex xs12>
              <v-switch
                label="Mostrar Tareas Frecuentes"
                v-model="mostrarTareasFrecuentes"
                false-value="false"
              ></v-switch>
            </v-flex>
            <v-flex xs12>
              <v-switch
                label="Mostrar Recordatorios"
                v-model="mostrarRecordatorios"
                false-value="false"
              ></v-switch>
            </v-flex>

            <v-flex xs12>
              <v-autocomplete
                v-model="empresaPredeterminadaId"
                :items="empresas"
                item-text="nombre"
                item-value="id"
                label="Empresa Predetetminada"
                placeholder="Seleccione una Empresa"
                :menu-props="{ minWidth: '400' }"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12>
              <v-autocomplete
                v-model="canalVentaPredeterminadoId"
                :items="canalesVenta"
                item-text="nombre"
                item-value="id"
                label="Canal de Venta Predetetminado"
                placeholder="Seleccione una Canal de Venta"
                :menu-props="{ minWidth: '400' }"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12>
              <v-autocomplete
                v-model="busquedaPersonaPor"
                :items="opcionesBusquedaPersonas"
                label="Búsqueda de Personas por (por defecto)"
                :menu-props="{ minWidth: '400' }"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs6 v-if="user.puedeAutorizar">
              <v-text-field
                v-if="user.puedeAutorizar"
                :prefix="user.iniciales"
                v-model="carCode"
                label="Código de Autorización Rápida (CAR)"
                v-validate="'required'"
                data-vv-name="CAR"
                :error-messages="errors.collect('CAR')"
                counter
                maxlength="4"
                :hint="
                  'Configure sus 4 dígitos. Luego para autorizar debe ingresar ' +
                    user.iniciales +
                    user.car
                "
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-if="user.puedeAutorizar">
              <v-btn outlined color="success" @click="saveCar"
                >Setear CAR <v-icon right>thumb_up</v-icon></v-btn
              >
            </v-flex>

            <v-flex xs12>
              <v-text-field
                v-if="ParametrosGenerales.integracionLlamadosAnura"
                v-model="numeroInterno"
                label="Número de Interno"
                counter
                maxlength="3"
                :hint="'Configure su número de interno.'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="user.sectorDescripcion"
                label="Sector"
                readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-flex offset-xs1>
          <v-flex xs12>
            <v-switch
              label="Debug Mode On"
              v-model="debugModeOn"
              false-value="false"
            ></v-switch>
          </v-flex>

          <div>Información</div>
          <div>> Ambiente: {{ ambiente.id }}</div>
          <div>> API: {{ ambiente.url }}</div>
        </v-flex>

        <v-spacer></v-spacer>
        <v-btn color="success" @click="save"
          ><v-icon>save</v-icon>Guardar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue';
import { http } from '@/axios';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  data() {
    return {
      temaOscuro: false,
      visible: false,
      mostrarTareasFrecuentes: false,
      mostrarRecordatorios: false,
      empresaPredeterminadaId: 0,
      canalVentaPredeterminadoId: 0,
      numeroInterno: null,
      debugModeOn: false,
      empresas: [],
      canalesVenta: [],
      busquedaPersonaPor: 'Documento',
      opcionesBusquedaPersonas: ['Documento', 'Cuil', 'Nombre', 'Operación'],
      carCode: '',
    };
  },
  props: {
    userName: {
      type: String,
      default: '',
    },
  },
  created() {
    this.loadEmpresas();
    this.loadCanalesVenta();
  },
  watch: {
    visible() {
      if (this.visible) {
        // me traigo el estado de los items customizables
        this.temaOscuro = this.UiCustomUserSettings.temaOscuro;
        this.mostrarTareasFrecuentes = this.UiCustomUserSettings.mostrarTareasFrecuentes;
        this.mostrarRecordatorios = this.UiCustomUserSettings.mostrarRecordatorios;
        this.empresaPredeterminadaId = this.UiCustomUserSettings.empresaPredeterminadaId;
        this.canalVentaPredeterminadoId = this.UiCustomUserSettings.canalVentaPredeterminadoId;
        this.busquedaPersonaPor = this.UiCustomUserSettings.busquedaPersonaPor;
        this.numeroIterno = this.UiCustomUserSettings.numeroIterno;

        this.debugModeOn = this.DebugModeOn;

        if (this.user.car) {
          console.log(this.user.car);
          this.carCode = this.user.car.substring(2, 6);
        }
      }
    },
    debugModeOn() {
      this.setDebugMode(this.debugModeOn);
    },
  },
  computed: {
    ...mapGetters([
      'UiCustomUserSettings',
      'user',
      'DebugModeOn',
      'ParametrosGenerales',
      'ambiente',
    ]),
  },
  methods: {
    //...mapMutations(['setUiCustomUserSettings']),
    ...mapActions(['setUiCustomUserSettings', 'setUserCAR']),
    ...mapMutations([
      'setDebugMode',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get('empresas'); // traigo todas
        this.empresas = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    async loadCanalesVenta() {
      this.loading = true;
      try {
        var result = await http.get(
          'canalesventa/habilitadosparausuario?soloActivos=true&usuarioId=' +
            this.user.id
        ); // traigo todas

        //var result = await http.get('canalesventa'); // traigo todas
        this.canalesVenta = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    async save() {
      this.UiCustomUserSettings.temaOscuro = this.temaOscuro;
      this.UiCustomUserSettings.mostrarTareasFrecuentes = this.mostrarTareasFrecuentes;
      this.UiCustomUserSettings.mostrarRecordatorios = this.mostrarRecordatorios;
      this.UiCustomUserSettings.empresaPredeterminadaId = this.empresaPredeterminadaId;
      this.UiCustomUserSettings.canalVentaPredeterminadoId = this.canalVentaPredeterminadoId;
      this.UiCustomUserSettings.busquedaPersonaPor = this.busquedaPersonaPor;
      this.UiCustomUserSettings.numeroInterno = this.numeroInterno;

      if (this.empresaPredeterminadaId > 0 && this.empresas.length > 0)
        this.UiCustomUserSettings.empresaPredeterminada = this.empresas.find(
          (e) => e.id == this.empresaPredeterminadaId
        ).nombre;

      Vue.$log.debug(this.canalVentaPredeterminadoId);
      Vue.$log.debug(this.canalesVenta);
      Vue.$log.debug(typeof this.empresas);
      Vue.$log.debug(typeof this.canalesVenta);
      if (this.canalVentaPredeterminadoId > 0 && this.canalesVenta.length > 0)
        this.UiCustomUserSettings.canalVentaPredeterminado = this.canalesVenta.find(
          (e) => e.id == this.canalVentaPredeterminadoId
        ).nombre;

      this.setUiCustomUserSettings(this.UiCustomUserSettings);
      this.visible = false;
    },
    async saveCar() {
      if (this.carCode.length != 4) {
        this.alertError('El CAR debe tener 4 dígitos, por favor, verifique.');
        return;
      }
      this.user.car = this.user.iniciales + this.carCode;
      this.setUserCAR(this.user);
    },
  },
};
</script>
